const isNullOrEmpty = (val) => {
    if (val == null || val == "" || val == undefined) {
        return true;
    }

    return false;
}

export default { isNullOrEmpty }